import { useState, useEffect } from 'react';
import { Route, HashRouter, Switch, Redirect } from "react-router-dom";
import VisionsAware from './pages/dashboard/Roi';
import Enrollment from './pages/dashboard/enrollment/Enrollment';
import Events from './pages/dashboard/events/Events';
import Layout from './components/Layout';
import "@fontsource/metropolis";
import TrafficAnalytics from './pages/dashboard/trafficanalytics/TrafficAnalytics';
import { QueryClientProvider, QueryClient } from 'react-query'
import { PageContext } from './context/page-context';
import { defaultPageSetting } from './context/page-context';
import { PageSetting } from './model/page';
import AuditLogReportsContainer from './pages/dashboard/AuditLogReports/AuditLogReportsContainer';


const queryClient = new QueryClient();

export default function App() {

  const [pageSetting, setPageSetting] = useState(defaultPageSetting);

  const setStoresFilter = (storesIndex: string[]) => {
    const newPageSetting: PageSetting = {
      ...pageSetting,
      activeFilter: {
        ...pageSetting.activeFilter,
        stores: storesIndex
      },
      setStores,
      setStoresFilter,
      setIsLoaded,
      filter: {
        ...pageSetting.filter,
        stores: pageSetting.filter.stores,
      },
      isLoaded: true
    };
    setPageSetting(newPageSetting);
  };

  const setStores = (stores: string[]) => {
    const newPageSetting: PageSetting = {
      ...pageSetting,
      filter: {
        ...pageSetting.filter,
        stores,
      },
      setStores,
      setStoresFilter,
      setIsLoaded
    };
    setPageSetting(newPageSetting);
  };

  const setIsLoaded = (isLoaded: boolean) => {
    const newPageSetting: PageSetting = {
      ...pageSetting,
      filter: {
        ...pageSetting.filter,
        stores: pageSetting.filter.stores
      },
      isLoaded,
      setStores,
      setStoresFilter,
      setIsLoaded
    };
    setPageSetting(newPageSetting);
  };

  useEffect(() => {
    const newPageSetting: PageSetting = {
      ...pageSetting,
      setStores,
      setStoresFilter,
      setIsLoaded
    };
    setPageSetting(newPageSetting);
  }, [pageSetting.activeFilter.stores, pageSetting.filter.stores, pageSetting.activeFilter]); // eslint-disable-line react-hooks/exhaustive-deps



  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Layout>
          <Switch>
            <Route exact={true} path="/"
              render={() => {
                return (<Redirect to="/roi" />)
              }}
            />
            <Route path="/roi" component={VisionsAware} />
            <Route path="/auditLogReports" component={AuditLogReportsContainer} />
            <PageContext.Provider value={pageSetting}>
              <Route path="/traffic/:categoryName" component={TrafficAnalytics} />
              <Route path="/enrollment/:categoryName?" component={Enrollment} />
              <Route path="/events/:categoryName?" component={Events} />
            </PageContext.Provider>
          </Switch>
        </Layout>
      </HashRouter>
    </QueryClientProvider>
  );
}

